import { animate, query, style, transition, trigger } from '@angular/animations';

export const popinAnimation = trigger('popin', [
  transition('void => *', [
    style({ backgroundColor: 'rgba(255, 255, 255, 0)' }),
    query('.popin', [style({ transform: 'translate(-50%, -50%) scale(0)' })]),
    animate(200),
    query('.popin', [
      animate('250ms cubic-bezier(.17,.67,.35,1.24)', style({ transform: 'translate(-50%, -50%) scale(1)' })),
    ]),
  ]),
  transition('* => void', [
    query('.popin', [style({ transform: 'translate(-50%, -50%) scale(1)' })]),
    query('.popin', [
      animate('250ms cubic-bezier(.54,.01,.3,.81)', style({ transform: 'translate(-50%, -50%) scale(0)' })),
    ]),
    animate(200, style({ backgroundColor: 'rgba(255, 255, 255, 0)' })),
  ]),
]);
